import React from 'react';
import {
    IProps as IQuickLinksBlockProps,
    IQuickLink,
} from './QuickLinksBlock.interface';
import { QuickLinksBlock } from './QuickLinksBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import * as translation from '@/utils/TranslationComponent/translation.utilities';

export interface IQuickLinksBlockLinkInputProps {
    text: string;
    target?: string | null;
    href: string;
    title?: string | null;
    background?: ThemeColors;
}

export interface IQuickLinksBlockInputProps {
    heading?: string;
    links?: IQuickLinksBlockLinkInputProps[];
    [key: string]: any; // Allows passthrough of other props
}

const mapInputToProps = (
    input: IQuickLinksBlockInputProps,
): IQuickLinksBlockProps => {

    const { heading, links, background, ...blockWrapper } = input;

    return {
        heading: heading || undefined,
        text: input.text || undefined,
        links: links?.map((link) =>
            translation.mapAnchorProps(link),
        ) as IQuickLink[],
        backgroundColor: background || 'white',
        ...blockWrapper
    } as IQuickLinksBlockProps; // Ensure the return type matches
};

const QuickLinksBlockTranslation: React.FC<IQuickLinksBlockInputProps> = (
    inputProps,
) => (
    <TranslationComponent
        inputProps={inputProps}
        TargetComponent={QuickLinksBlock}
        mapProps={mapInputToProps}
    />
);

export default QuickLinksBlockTranslation;
